//dependencias
import React, { Component } from 'react';

//componentes
import ReferenciaC from './referenciaC'

class Index extends Component {

    render(){
        return(
            <div>
                <ReferenciaC />
            </div>
        );
    }

}
export default Index;